// Centralized dayjs setup. Registers every plugin used in the codebase
// once at module load. Subsequent `import dayjs from "dayjs"` in any
// file will see the same fully-extended dayjs instance, since the
// module is a singleton.
//
// Plugins enabled:
//   relativeTime      → .fromNow(), .from(), .toNow(), .to()
//   duration          → dayjs.duration(...)
//   customParseFormat → dayjs(value, "DD/MM/YYYY") parsing
//   localizedFormat   → .format("L"), .format("LL"), .format("LT"), etc.
//   isBetween         → .isBetween(a, b, unit, "[]")
//   isoWeek           → ISO week support (Mon-first weeks, .isoWeek())
//
// Imported for side effects from src/index.js.

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(isBetween);
dayjs.extend(isoWeek);

export default dayjs;
